import { defineStore } from 'pinia';
import { RoomTypeAvailability } from 'src/types';
import { RateDTO } from 'src/services/api/data-contracts';

export const useSelectStateStore = defineStore('selectStateStore', {
  state: () => ({
    roomType: null as RoomTypeAvailability,
    rate: null as RateDTO,
  }),
  getters: {},
  actions: {
    clear() {
      this.rate = null;
      this.roomType = null;
    },
  },
});
